import { render } from "./Math.vue?vue&type=template&id=c3f54aa6&scoped=true"
import script from "./Math.vue?vue&type=script&lang=js"
export * from "./Math.vue?vue&type=script&lang=js"

import "./Math.vue?vue&type=style&index=0&id=c3f54aa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f54aa6"]])

export default __exports__